// extracted by mini-css-extract-plugin
export var component = "AboutBlock-module--component--924d7";
export var fadePop = "AboutBlock-module--fade-pop--d4db5";
export var growHeightIn = "AboutBlock-module--grow-height-in--b2d9e";
export var statementButtonWrapper = "AboutBlock-module--statementButtonWrapper--3d383";